<template>
  <div>
    <the-nav-bar :title="$t('payInfo.name')" />
    <md-field class="body-wrapper">
      <md-field-item
        v-for="(item, index) in settings"
        :key="index"
        :title="item.title"
        :content="item.content"
        :placeholder="item.placeholder"
        @click="item.event"
        :arrow="item.hasArrow"
      ></md-field-item>
      <div class="info-wrapper" slot="footer">
        {{ $t('payInfo.settingInfo') }}
      </div>
    </md-field>
    <!-- <md-selector
      v-model="isShowCurrencySetting"
      :default-value="userInfo.defaultLegalCurrencyId"
      max-height="100vw"
      :title="$t('payInfo.settings[0].title')"
      :data="currencyList"
      large-radius
      @choose="onChoose"
    ></md-selector> -->
    <md-popup position="bottom" preventScroll v-model="isShowCurrencySetting">
      <md-popup-title-bar
        :title="$t('payInfo.settings[0].title')"
        large-radius
        only-close
        @cancel="onPopupChange"
        title-align="left"
      ></md-popup-title-bar>
      <div class="popup-body">
        <div class="filter">
          <md-input-item
            v-model.trim="filterKey"
            type="text"
            :placeholder="$t('exchange.filterLegalCurrency')"
            @change="onFilterKeyChanged"
          ></md-input-item>
        </div>
        <div class="scroll-wrapper">
          <md-scroll-view :scrolling-x="false" auto-reflow>
            <div class="scroller">
              <div
                class="item"
                v-for="item in computedCurrencyList"
                :key="item.value"
                :class="
                  defaultCurrency && defaultCurrency.id == item.value
                    ? 'active'
                    : ''
                "
                @click="onChoose(item)"
              >
                {{ item.text }}
              </div>
              <div class="item row-center" v-if="!computedCurrencyList.length">
                {{ $t('exchange.notFound') }}
              </div>
            </div>
          </md-scroll-view>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Field,
  FieldItem,
  Dialog,
  Toast,
  Selector,
  Popup,
  PopupTitleBar,
  ScrollView,
  InputItem,
} from 'mand-mobile';
import { mapState } from 'vuex';
import { getMixinAuth } from '@/api/user';
export default {
  components: {
    TheNavBar,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [Selector.name]: Selector,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [ScrollView.name]: ScrollView,
    [InputItem.name]: InputItem,
  },
  data() {
    return {
      isShowCurrencySetting: false,
      filterKey: '',
      searchKey: '',
      timeout: null,
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapState({
      legalCurrencyList: state => state.settings.legalCurrencyList,
      isSettingsLoaded: state => state.settings.isSettingsLoaded,
    }),
    currencyList() {
      return this.legalCurrencyList.map(item => {
        return {
          value: item.id,
          text: `${item.name} (${item.unit})`,
        };
      });
    },
    computedCurrencyList() {
      return this.currencyList.filter(item => {
        if (!this.searchKey) return true;
        const key = this.searchKey.toLowerCase();
        const str = item.text.toLowerCase();
        return str.indexOf(key) > -1;
      });
    },
    defaultCurrency() {
      return (
        this.legalCurrencyList.find(
          item => item.id == this.userInfo.defaultLegalCurrencyId,
        ) || null
      );
    },
    settings() {
      return [
        {
          title: this.$t('payInfo.settings[0].title'),
          content: this.defaultCurrency
            ? `${this.defaultCurrency.name} (${this.defaultCurrency.unit})`
            : '',
          placeholder: this.$t('payInfo.settings[0].placeholder'),
          hasArrow: true,
          event: this.showCurrencySetting,
        },
        {
          title: this.$t('payInfo.settings[1].title'),
          content: this.userInfo.hasPayMethods
            ? this.$t('payInfo.settings[1].content')
            : '',
          placeholder: this.$t('payInfo.settings[1].placeholder'),
          hasArrow: true,
          event: this.goPayInfoList,
        },
        {
          title: this.$t('payInfo.settings[2].title'),
          content: this.userInfo.phone,
          placeholder: this.$t('payInfo.settings[2].placeholder'),
          event: this.authorize,
          hasArrow: !this.userInfo.phone,
        },
        // {
        //   title: this.$t('payInfo.settings[3].title'),
        //   content: this.userInfo.inviter ? this.userInfo.inviter : '',
        //   placeholder: this.$t('payInfo.settings[3].placeholder'),
        //   event: this.goBindInviteCode,
        //   hasArrow: !this.userInfo.inviter && !this.userInfo.hasTraded,
        // },
        {
          title: this.$t('payInfo.settings[4].title'),
          content: this.userInfo.hasVerified ? this.$t('payInfo.passed') : '',
          placeholder: this.$t('payInfo.settings[4].placeholder'),
          event: this.goKyc,
          hasArrow: !this.userInfo.hasVerified,
        },
        {
          title: this.$t('payInfo.settings[5].title'),
          content: (this.userInfo.hasVerified && this.userInfo.advKycLevel=== 1 )? this.$t('payInfo.passed') : '',
          placeholder: this.$t('payInfo.settings[5].placeholder'),
          event: this.goAdvKyc,
          hasArrow: !(this.userInfo.advKycLevel===1),
        },
        {
          title: this.$t('payInfo.settings[6].title'),
          content: this.userInfo.videoKycLevel > 0? this.$t('payInfo.passed') : '',
          placeholder: this.$t('payInfo.settings[6].placeholder'),
          hasArrow: true,
          event: this.goVideoKyc,
        },
        // {
        //   title: this.$t('apply.name'),
        //   content: (this.userInfo.hasVerified && this.userInfo.hasCertified )? this.$t('payInfo.passed') : '',
        //   placeholder: this.$t('apply.clickPlaceholder'),
        //   event: this.goApplyLandun,
        //   hasArrow: !this.userInfo.hasCertified,
        // },
      ];
    },
  },
  created() {
    let p1 = Promise.resolve(),
      p3 = this.$store.dispatch('updateUserInfo');
    if (!this.isSettingsLoaded) {
      p1 = this.$store.dispatch('updateSettings');
    }

    Promise.all([p1, p3])
      .then(() => {})
      .catch(err => {
        Toast.failed(err.message);
      });
  },
  methods: {
    goPayInfoList() {
      if (this.userInfo.hasVerified ) {
        this.$router.push('/mine/payInfo/list');
      } else {
        Dialog.alert({
          title: this.$t('common.notice'),
          content: this.$t('payInfo.noKycAlert'),
          confirmText: this.$t('common.confirm'),
        });
      }
    },
    goBindInviteCode() {
      if (this.userInfo.inviter ) return;
      if (this.userInfo.hasTraded){
        Dialog.alert({
          title: this.$t('common.notice'),
          content: this.$t('payInfo.bindRuleErrorInfo'),
          confirmText: this.$t('common.confirm'),
        }); 
        return;
      }

      this.$router.push('/mine/inviteCode');
    },
    showCurrencySetting() {
      this.isShowCurrencySetting = true;
    },
    onChoose(obj) {
      Toast.loading(this.$t('common.loading'));
      this.$store
        .dispatch('updateUserCurrency', obj.value)
        .then(() => {
          Toast.hide();
          this.onPopupChange();
        })
        .catch(err => {
          Toast.failed(err.message);
        });
    },
    authorize() {
      if (this.userInfo.phone) return;
      Dialog.confirm({
        title: this.$t('common.notice'),
        content: this.$t('payInfo.authorizeAlert'),
        cancelText: this.$t('common.cancel'),
        confirmText: this.$t('common.known'),
        onConfirm: () => {
          Toast.loading(this.$t('common.loading'));
          getMixinAuth()
            .then(data => {
              Toast.hide();
              return window.location.replace(data.data.url);
            })
            .catch(err => {
              Toast.failed(err.message);
            });
        },
      });
    },
    onPopupChange() {
      this.isShowCurrencySetting = !this.isShowCurrencySetting;
      if (!this.isShowCurrencySetting) {
        clearTimeout(this.timeout);
        this.filterKey = '';
        this.searchKey = '';
      }
    },
    onFilterKeyChanged() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.searchKey = this.filterKey;
      }, 500);
    },
    goKyc() {
      // if (this.userInfo.hasVerified) return;
      this.$router.push('/mine/kyc');
    },
    goAdvKyc() {
      if (this.userInfo.advKycLevel === 1) return;
      if (this.userInfo.hasVerified) {
        this.$router.push('/mine/kycAdv');
      } else {
        Dialog.alert({
          title: this.$t('common.notice'),
          content: this.$t('payInfo.noKycAlert'),
          confirmText: this.$t('common.confirm'),
        });
      }
    },
    goVideoKyc(){
      this.$router.push('/mine/kycVideo');
    },
    goApplyLandun(){
      if (this.userInfo.hasVerified) {
        if(this.userInfo.advKycLevel !== 1){
          Dialog.alert({
            title: this.$t('common.notice'),
            content: this.$t('payInfo.noKycAdvAlert'),
            confirmText: this.$t('common.confirm'),
          });  
        }else{
          if(this.userInfo.isOversea){
            this.$router.push('/mine/applyInternational');
          }else{
            this.$router.push('/mine/applyCertification');
          }
        }
      } else {
        Dialog.alert({
          title: this.$t('common.notice'),
          content: this.$t('payInfo.noKycAlert'),
          confirmText: this.$t('common.confirm'),
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding-left: 0;
  padding-right: 0;

  .md-field-item:nth-child(even) {
    background: #f8fbfc;
  }

  & >>> {
    .md-field-item-content {
      min-height: 17.07vw;
      padding: 0 4.8vw;

      &:before {
        content: none;
      }
    }

    .md-field-item-title {
      font-size: 3.73vw;
      font-weight: bold;
    }

    .md-field-item-control {
      font-size: 3.73vw;
      font-weight: normal;
      text-align: right;
      color: color-primary;
    }
  }

  .info-wrapper {
    margin: 9.6vw 4.8vw 0;
    color: #84969c;
  }
}

.popup-body {
  background: #fff;

  .scroll-wrapper {
    height: 100vw;
  }

  .scroller {
    padding-bottom: 40vw;
  }

  .item {
    text-align: center;
    height: 9.6vw;
    line-height: 9.6vw;
    font-size: 3.73vw;

    &.active {
      color: color-primary;
    }
  }

  .filter {
    padding: 2.4vw 4.8vw;

    .md-input-item {
      border: 0.27vw solid #eaf1f3;
      padding: 0 2.67vw;
      border-radius: 2.67vw;
      background: #f8fbfc;

      & >>> {
        .md-field-item-content:before {
          content: none;
        }

        .md-field-item-left {
          margin-right: 5.33vw;
          color: #B4C2C7;
        }
      }
    }
  }
}
</style>
